// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import { Box, Link, SpeedDial, SpeedDialIcon, SpeedDialAction, Tab, Tabs, Typography, } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// TODO: Import MUI icon
import { MenuBook } from '@mui/icons-material';

// TODO: Import context
import { Context } from '../../Common/Context';
import { Text } from '../../Common/Text';

// TODO: Import custom component
import Slide from '../Slide_LT.jpg';

import BoxSubPage from '../../Common/BoxSubPage';
import BoxImage from '../../Common/BoxImage';
import { BoxGridColumnsContainer } from '../../Common/BoxGridColumns';

const EnglishEducation = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component EnglishEducation Rendered');

    // TODO: Define useContext
    const context = React.useContext(Context);

    // TODO: Define variable
    const actions = [
        'SCOLAR Speaking for All',
        'SCOLAR Impromptu Speaking',
        'Drama Appreciation',
        'Study Tour(UK)',
        'Study Tour(Croatia)',
        'Hong Kong Schools Speech Festival Achievements',
        'Greater Bay Area Speech Festival Achievements',
    ];
    const [value, setValue] = React.useState(actions[0]);
    const [open, setOpen] = React.useState(false);

    // TODO: Define event
    const theme = useTheme();

    const handleChange = (event, newValue) => { setValue(newValue) };

    React.useEffect(() => { window.scrollTo(0, 0); }, [value]);
    React.useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.innerHeight + window.scrollY;
            const documentHeight = document.documentElement.scrollHeight;

            if (documentHeight - scrollPosition < 200) {
                setOpen(true);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // TODO: Return component
    return (
        <BoxSubPage
            id="EnglishEducation"
            image={Slide}
            title={Text.Top.Menu['LT'].Title[context.language]}
            subtitles={Text.Top.Menu['LT'].Subtitles}
        >
            <Box sx={{ display: { xs: 'none', md: 'inline' }, mb: 2, maxWidth: { xs: '480px', lg: '700px' } }}>
                <Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons="auto">
                    {actions.map((action) => <Tab key={action} icon={<MenuBook />} value={action} label={action} sx={{ maxWidth: '168px' }} wrapped />)}
                </Tabs>
            </Box>
            <Typography variant="h6" sx={{ color: 'primary.main', mb: 2, display: { xs: 'inline', md: 'none' } }}>{value}</Typography>
            <SpeedDial
                ariaLabel="SpeedDial tooltip example"
                sx={{ alignItems: 'end', display: { xs: 'flex', md: 'none' }, position: 'fixed', bottom: 16, right: 16 }}
                icon={<SpeedDialIcon />}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                open={open}
            >
                {actions.map((action) => (
                    <SpeedDialAction
                        key={action}
                        FabProps={{
                            sx: {
                                backgroundImage: `linear-gradient(90deg, ${theme.palette.secondary.dark}, ${theme.palette.secondary.light})`,
                                backgroundSize: '200% 200%',
                                justifyContent: 'start',
                                height: 'auto',
                                maxWidth: '300px',
                                padding: '8px 8px',
                                '&:hover': { backgroundColor: 'secondary.light', },
                            },
                            variant: 'extended'
                        }}
                        icon={
                            <Typography
                                style={{
                                    alignItems: 'center',
                                    color: 'black',
                                    display: 'flex',
                                    gap: 8,
                                    textAlign: 'left',
                                    textDecoration: 'none',
                                }}
                            >
                                <MenuBook />
                                <span dangerouslySetInnerHTML={{ __html: action }}></span>
                            </Typography>
                        }
                        onClick={() => {
                            setOpen(false);
                            setValue(action);
                        }}
                    />
                ))}
            </SpeedDial>
            {value === actions[0] &&
                <Box>
                    <BoxImage src={`https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/SCOLARSpeakingForAll_05.jpg`} sx={{ mb: 1, width: 1 }} />
                    <Typography sx={{ mb: 1 }}>
                        The SCOLAR Speaking for ALL activity is a fantastic multicultural experience where our students connect with overseas university students. They love engaging in conversations that broaden their horizons and allow them to use English in an authentic environment. This lively exchange fosters confidence and enthusiasm as they share ideas and learn about different cultures. It’s a wonderful opportunity for students to practice their speaking skills while making new friends and gaining valuable insights into the world beyond their classrooms!
                    </Typography>
                    <BoxGridColumnsContainer>
                        <BoxImage src={`https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/SCOLARSpeakingForAll_07.jpg`} />
                        <BoxImage src={`https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/SCOLARSpeakingForAll_08.jpg`} />
                        <BoxImage src={`https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/SCOLARSpeakingForAll_09.jpg`} />
                        <BoxImage src={`https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/SCOLARSpeakingForAll_10.jpg`} />
                        <BoxImage src={`https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/SCOLARSpeakingForAll_01.jpg`} />
                        <BoxImage src={`https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/SCOLARSpeakingForAll_02.jpg`} />
                    </BoxGridColumnsContainer>
                </Box>}
            {value === actions[1] &&
                <Box>
                    <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/SCOLARImpromptuSpeaking_01.jpg" sx={{ mb: 1, width: 1 }} />
                    <Typography sx={{ mb: 1 }}>
                        The SCOLAR Impromptu Speaking activity is an exciting opportunity for students to develop their public speaking skills with guidance from a native-speaking teacher. During this engaging session, students face the challenge of speaking on the spot, making breakthroughs they rarely experience in their everyday classrooms. It boosts their confidence and helps them express their thoughts more clearly. This unique chance to practice impromptu speaking not only enhances their communication skills but also encourages them to share their ideas in fun and dynamic ways!
                    </Typography>
                    <BoxGridColumnsContainer>
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/SCOLARImpromptuSpeaking_03.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/SCOLARImpromptuSpeaking_04.jpg" />
                    </BoxGridColumnsContainer>
                </Box>}
            {value === actions[2] &&
                <Box>
                    <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/DramaAppreciation_07.jpg" sx={{ mb: 1, width: 1 }} />
                    <Typography sx={{ mb: 1 }}>
                        The Drama Appreciation (Anti-Bullying) activity is a hit with students, many of whom are seeing a play in complete English without subtitles for the first time! They love the interactive elements and engaging performances that highlight important themes about kindness and respect. This unique experience not only entertains but also sparks conversations about bullying and empathy among peers. It's a fantastic way for students to appreciate drama while gaining valuable insights into social issues, all while having a great time!
                    </Typography>
                    <BoxGridColumnsContainer>
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/DramaAppreciation_17.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/DramaAppreciation_19.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/DramaAppreciation_27.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/DramaAppreciation_28.jpg" />
                    </BoxGridColumnsContainer>
                </Box>}
            {value === actions[3] &&
                <Box>
                    <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/StudyTourUK_15.jpg" sx={{ mb: 1, width: 1 }} />
                    <Typography sx={{ mb: 1 }}>
                        In the summer of 2024, our students had an amazing time on a study tour to England! They explored incredible places like Oxford, the Harry Potter Studio, and all the must-see spots in London.
                    </Typography>
                    <Typography sx={{ mb: 1 }}>
                        Staying in a dorm at Cambridge University was a highlight, giving them a taste of campus life and sparking their curiosity about higher education. They made new friends, improved their communication skills, and really embraced British culture. It was an unforgettable adventure that inspired them to chase their dreams!
                    </Typography>
                    <BoxGridColumnsContainer>
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/StudyTourUK_05.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/StudyTourUK_06.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/StudyTourUK_07.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/StudyTourUK_08.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/StudyTourUK_09.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/StudyTourUK_10.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/StudyTourUK_17.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/StudyTourUK_18.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/StudyTourUK_19.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/StudyTourUK_20.jpg" />
                    </BoxGridColumnsContainer>
                </Box>}
            {value === actions[4] &&
                <Box>
                    <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/StudyTourCroatia_01.jpg" sx={{ mb: 1, width: 1 }} />
                    <Typography sx={{ mb: 1 }}>
                        In the summer of 2025, our students explored the stunning Dubrovnik Old Town, marveled at Diocletian's Palace, and experienced the natural beauty of Plitvice Lakes National Park. They also visited Rimac Automobili and Algebra University, gaining insights into innovation and education. A highlight of the trip was crossing the impressive Pelješac Bridge. This adventure was a golden opportunity for our students to learn and grow in a vibrant culture!
                    </Typography>
                    <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/StudyTourCroatia_02.jpg" sx={{ mb: 1, width: 1 }} />
                </Box>}
            {value === actions[5] &&
                <Box>
                    <Typography sx={{ mb: 1 }}>
                        Every year, all students who participate in the Hong Kong Schools Speech Festival are celebrated for their hard work. Let’s explore some of our biggest celebratory moments, in which our students won and placed!
                    </Typography>
                    <Typography sx={{ color: 'primary.main', textDecoration: 'underline', mb: 1 }}>
                        77th Hong Kong Schools Speech Festival
                    </Typography>
                    <Typography>
                        Mixed Secondary 3&4 Choral Speaking
                    </Typography>
                    <Typography sx={{ mb: 1 }}>
                        Achieved: 2nd Runner-Up
                    </Typography>
                    <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/SpeechFestivalAchievements_16.jpg" sx={{ mb: 1, width: 1 }} />
                    <Typography>See more:</Typography>
                    <Box sx={{ mb: 3 }}>
                        <Link href="https://www.pohtyh.edu.hk/Album?ID=20260428">
                            https://www.pohtyh.edu.hk/Album?ID=20260428
                        </Link>
                    </Box>
                    <Typography sx={{ color: 'primary.main', textDecoration: 'underline', mb: 1 }}>
                        76th Hong Kong Schools Speech Festival
                    </Typography>
                    <Typography>
                        Mixed Secondary 3&4 Choral Speaking
                    </Typography>
                    <Typography sx={{ mb: 1 }}>
                        Achieved: Champion
                    </Typography>
                    <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/SpeechFestivalAchievements_17.jpg" sx={{ mb: 1, width: 1 }} />
                    <Typography>
                        See more:
                    </Typography>
                    <Box sx={{ mb: 3, maxWidth: { xs: '280px', sm: '520px', md: '800px' }, wordWrap: 'break-word' }}>
                        <Link href="https://www.pohtyh.edu.hk/P202502111110_ChoralSpeakingChampions">
                            https://www.pohtyh.edu.hk/P202502111110_ChoralSpeakingChampions
                        </Link>
                    </Box>
                    <Typography sx={{ mb: 1 }}>
                        Congratulations to the winners and participants of the Solo Verse, Dramatic Duologue and News Feature Presentation categories!
                    </Typography>
                    <BoxGridColumnsContainer>
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/SpeechFestivalAchievements_07.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/GreaterBayArea_07.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/SpeechFestivalAchievements_01.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/SpeechFestivalAchievements_09.jpg" />
                    </BoxGridColumnsContainer>
                </Box>}
            {value === actions[6] &&
                <Box>
                    <Typography sx={{ color: 'primary.main', textDecoration: 'underline', mb: 1 }}>
                        Greater Bay Area Speech Festival 2025
                    </Typography>
                    <Typography>
                        Secondary 3 Choral Speaking
                    </Typography>
                    <Typography sx={{ mb: 1 }}>
                        Achieved: Champion
                    </Typography>
                    <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/GreaterBayArea_05.jpg" sx={{ mb: 1, width: 1 }} />
                    <Typography>
                        Secondary 1 Choral Speaking
                    </Typography>
                    <Typography sx={{ mb: 1 }}>
                        Achieved: Champion
                    </Typography>
                    <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/GreaterBayArea_06.jpg" sx={{ mb: 1, width: 1 }} />
                    <Typography sx={{ color: 'primary.main', textDecoration: 'underline', mb: 1 }}>
                        Greater Bay Area Speech Festival 2024
                    </Typography>
                    <Typography>
                        Secondary 3 Choral Speaking
                    </Typography>
                    <Typography sx={{ mb: 1 }}>
                        Achieved: Champion
                    </Typography>
                    <Typography>
                        Secondary 1 Choral Speaking
                    </Typography>
                    <Typography sx={{ mb: 1 }}>
                        Achieved: Silver Award (2nd Place)
                    </Typography>
                    <Typography>
                        Congratulations to the winners and participants of the Solo Verse, Dramatic Duologue and News Feature Presentation categories!
                    </Typography>
                    <BoxGridColumnsContainer>
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/GreaterBayArea_01.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/GreaterBayArea_03.jpg" />
                    </BoxGridColumnsContainer>
                </Box>}
        </BoxSubPage>
    );
};
export default EnglishEducation;